import { Next } from "koa"
import Router from "@koa/router"
import { context, env } from "@budibase/backend-core"
import { Ctx } from "@budibase/types"
import { logger } from "../sdk/scim"

export const doInScimContext: Router.Middleware<any, any> = async (
  ctx: Ctx,
  next: Next
) => {
  // let logId: string | undefined
  if (!env.DISABLE_SCIM_CALLS) {
    await logger.logRequest({
      // koa response stringify only returns status, message and header
      ...ctx.request.toJSON(),
      body: ctx.request.body,
    })
  }
  return await context.doInScimContext(async () => {
    const result = await next()
    await logger.logResponse({
      // koa response stringify only returns status, message and header
      ...ctx.response.toJSON(),
      body: ctx.response.body,
    })
    return result
  })
}
